import { Component, Input} from '@angular/core';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { AddResumeComponent } from '../../../authentication/components/add-resume/add-resume.component';
import { JobApplyObject } from '../../../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { AuthenticationComponent } from '../../../authentication/authentication.component';
import { CandidateProfileComponent } from '../../../candidate-profile/candidate-profile.component';
import { ReviewCandidateProfileComponent } from '../../../review-candidate-profile/review-candidate-profile.component';
import { JobAssessmentComponent } from '../job-assessment/job-assessment.component';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { JobDetailsDTO } from '../../../../../../../UI/src/app/shared/job/job-details.dto';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import { TranslateService } from '@ngx-translate/core';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { AuthenticationService } from '../../../../../../../UI/src/app/shared/authentication/authentication.service';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import { GeoLocationService } from '../../../../../../../UI/src/app/shared/location/geo-location.service';
import { JobSearchComponent } from '../../job-search.component';
@Component({
  selector: 'page-job-details',
  templateUrl: 'job-details.component.html'
})
export class JobDetailsPage {
  showJobStatusHeader: boolean = false;;
  addResumeComponent: any = AddResumeComponent;
  jobAssessmentComponent: any = JobAssessmentComponent;
  candidateProfileComponent: any = CandidateProfileComponent;
  JobSearchComponent: any = JobSearchComponent;
  job: any;
  alertData: any;
  jobDetails: JobDetailsDTO = null;
  goToThirdStep: boolean = true;
  loading;
  jobdetailsLoaded: boolean = false;

  private showApplyButton: boolean = true;
  private profileExists = false;
  private resumeExists = false;
  jobDetailsTranslations: any;
  resumeData: any;
  navigatedFrom = '';
  isApplyWithLinkedIn : boolean;
  isLoggedin= this.authenticationService.isUserLoggedin();
  private enableLinkedIn = 'REC_ENABLE_LINKEDIN';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public jobService: JobService,
    public profileService: ProfileService,
    private toastService: ToastControllerService,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private toast508Service: Toast508Service,
    private resumeService : ResumeService,
    private authenticationService: AuthenticationService,
    private settingsService: SettingsService,
    private geoLocationService: GeoLocationService,
  ) {
    this.translate.get(['CAREER_APPLIED_SUCCESS',
      'CAREER_ALREADY_APPLIED',
      'CAREER_FAILED_MESSAGE'
    ]).subscribe((obj) => {
      this.jobDetailsTranslations = obj;
    });

    this.job = navParams.get("jobData");
    this.navigatedFrom = navParams.get("navigatedFrom");

    if (this.job  == undefined || this.job.id == undefined || this.job.id == 0) {
      if(navParams.get("jobId")) {
        this.job = {};
        this.job.id = navParams.get("jobId");
    }

    if(navParams.data.isJobSubmitted != undefined)
    {
      jobService.IsJobApplied = navParams.get("isJobSubmitted");
    }
  }

    if (this.job.submitted != undefined) {
      this.showJobStatusHeader = this.job.submitted;
    }
    this.jobService.setSuccessAlert(-1);
    this.showAlert();
    this.loading = this.loadingCtrl.create({
      duration: 5000
    });
    if(window.localStorage.getItem(Storage.AUTH_TOKEN) != null) {
    this.getResumeData();
    }
    const alertStatus = this.jobService.getSuccessAlert();
    if (alertStatus === 1) {
      this.showApplyButton = false;
    }
    if (this.isLoggedin) {
    this.events.publish('showSiteMapNodes', true);
    } else {
      this.events.publish('showSiteMapNodesPublic', true);
    }
  }

  applyRequisition(jobId,userId,isValidateJobApply) {
    this.jobService.applyRequisition(jobId, '', isValidateJobApply)
       .subscribe((response) => {
         if (response && response !== '') {
          this.jobService.jobApplyalertData = { message: response, type: 'warning' };
          this.jobService.canUserApplyJob = true;
          this.jobService.setSuccessAlert(5);
          this.showAlert();
         }
         else
         {
          this.jobService.canUserApplyJob = false;
          this.jobService.jobApplyalertData = null;
         }
       }, (error) => {
       });
    }

    ngOnInit() {
    this.getJobDescription();
    this.getLinkedInDetails();
    if(this.job && this.job.isApplied==false && window.localStorage.getItem(Storage.AUTH_TOKEN) != null){
    this.applyRequisition(this.job.id,'',true);
    }
  }
  ionViewWillLeave() {

    if(this.jobService.IsJobApplied == false)
    {
      if(this.navigatedFrom == "CandidateProfileComponent")
      {
        this.navCtrl.setRoot(CandidateProfileComponent);
      }
      else
      {
        this.navCtrl.setRoot(JobSearchComponent);

      }
    }
  }
  onApply() {
    this.jobService.IsJobApplied  = undefined;
    this.ngOnInit();
    if (!this.profileExists) {
      const jobApplyObject: JobApplyObject = new JobApplyObject();
        jobApplyObject.LaunchedFrom=this.navigatedFrom;
        jobApplyObject.JobId = this.job.id;
        this.jobService.setApplyJobObject(jobApplyObject);
      // If no profile ask for profile setup
      this.navCtrl.push(AuthenticationComponent, { "action": "request", "isJobApply": true });
    } else {
      // If profileExists & resumeExists
      if (this.resumeExists) {
          if (this.job != undefined && this.job.isDrafted != undefined && this.job.isDrafted) {
          const jobApplyObject: JobApplyObject = this.jobService.getApplyJobObject();
          if (jobApplyObject != null && jobApplyObject.JobId != null) {
            this.jobService.getAssessmentIdForRequisition(jobApplyObject.JobId)
            .subscribe((response) => {
              if(response === 0 || response === null) {
                this.profileService.applyJob(jobApplyObject.JobId).subscribe(
                  (response) => {
                    if (response > 0) {
                      // Job Applied
                      this.jobService.setSuccessAlert(0);
                      this.authenticationService.isAppliedwithLinkedIn=false;
                    } else if (response === -1) {
                      // Job Already Applied
                      this.jobService.setSuccessAlert(1);
                    } else if (response === -50) {
                      // Job Applied Failure
                      this.jobService.setSuccessAlert(2);
                    }
                    this.showAlert();
                    this.navCtrl.pop();
                  }, (error) => {

                  });
              } else {
               this.navCtrl.push(this.jobAssessmentComponent, {"assessmentId":response, "jobId": jobApplyObject.JobId, "navigatedFrom": this.navigatedFrom, "applicationId": this.job.applicationId, isDrafted: this.job.isDrafted, "isAssessment":false});
              }
            }, (error) => {
              this.alertData = { message: this.jobDetailsTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
            });
          }
        } else {
          this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false, isJobApply: true, showNavbar: true});
          this.navCtrl.push(ReviewCandidateProfileComponent, {"navigatedFrom": this.navigatedFrom});
        }
      }
      else {
        this.resumeService.setResumeAction({action: 'CREATE_RESUME', isInititalCreation: true, isJobApply: true});
        this.navCtrl.push(this.addResumeComponent, this.goToThirdStep);
      }
    }
  }

  ionViewWillEnter() {
    // Find Resume Exists  or not
    if (window.localStorage.getItem(Storage.AUTH_TOKEN) != null) {
      this.profileExists = true;
      this.profileService.getProfileData().subscribe(
        (response) => {
          if (response[0].resumeType !== 0) {
            this.resumeExists = true;
          }
        }, (error) => {
          // TODO : Implement alert
        }
      );
    }
  }
  ionViewCanLeave() {
    if (this.job.submitted) {
      this.navCtrl.setRoot(this.candidateProfileComponent, true);
    }
  }

  showAlert() {
    const jobApplyStatus = this.jobService.getSuccessAlert();
    if (jobApplyStatus === 0) {
      this.alertData = {
        message: this.jobDetailsTranslations.CAREER_APPLIED_SUCCESS,
        type: 'success'
      };
      this.jobService.setSuccessAlert(3);
      this.showApplyButton = false;
    } else if (jobApplyStatus === 1) {
      this.alertData = { message: this.jobDetailsTranslations.CAREER_ALREADY_APPLIED, type: 'info' };
      this.jobService.setSuccessAlert(3);
      this.showApplyButton = false;
    } else if (jobApplyStatus === 2) {
      this.alertData = { message: this.jobDetailsTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
      this.jobService.setSuccessAlert(3);
    } else if (jobApplyStatus === 5) {
      this.alertData = this.jobService.jobApplyalertData;
      this.jobService.setSuccessAlert(5);
    } else {
      this.alertData = null;
      this.jobService.jobApplyalertData = null;
    }

    if (this.alertData != null)
      this.toastService.presentToast(this.alertData);
      this.toast508Service.toFocus();
  }

  private getJobDescription() {
    this.loading.present();
    this.jobDetails = new JobDetailsDTO();
    this.jobService.getJobDetails(this.job.id).subscribe(
      (response) => {
        this.loading.dismiss();
        this.jobDetails = response;
        this.job = response;
        this.jobdetailsLoaded = true;
        const jobApplyObject: JobApplyObject = new JobApplyObject();
        jobApplyObject.JobId = this.job.id;
        jobApplyObject.ApplicationId = response.applicationId;
        jobApplyObject.IsDrafted = response.isDrafted;
        jobApplyObject.LaunchedFrom = this.navigatedFrom;
        this.jobService.setApplyJobObject(jobApplyObject);
      }, (error) => {
        console.log('data not recieved');
      });
    }
    private getLinkedInDetails()
    {
      this.loading.present();
      this.settingsService.GetLoginSettings().subscribe(
        response=>{
          this.loading.dismiss();
          this.isApplyWithLinkedIn = response.filter(response => response.key === this.enableLinkedIn)[0].value;
        });
    }

  private getResumeData() {
    this.resumeService.getResumeData().subscribe(
      (response) => {
        this.resumeData = response;
      }, (error) => {
        // TODO : Implement alert
      });
    }

  private  getLocationAccess() {
    this.geoLocationService.getCurrentPosition().subscribe(
        (response) => {
          if (response !== undefined) {
            this.geoLocationService.setLongitide(response.coords.longitude);
            this.geoLocationService.setlatitude(response.coords.latitude);
            this.geoLocationService.setAccessCount();
          }
        }, (error) => {
        }
    );
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/job-details/job-details.component.ts